export default "__VITE_ASSET__cvdBiETQ__"